import React, { useState } from 'react';
import { 
  Box, 
  Paper, 
  Typography, 
  TextField, 
  Button, 
  Container,
  Alert,
  Stack,
  Link,
  Avatar
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

const DashboardLogin: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Check if it's the admin user
      if (username === 'TBAdmin' && password === 'password123') {
        const success = await login(username, password);
        if (success) {
          navigate('/dashboard');
        } else {
          setError('Authentication failed');
        }
      } else {
        setError('Invalid admin credentials');
      }
    } catch (error) {
      setError('An error occurred during login');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Button 
          startIcon={<ArrowBackIcon />} 
          sx={{ alignSelf: 'flex-start', mb: 2 }}
          onClick={() => navigate('/')}
        >
          Back to Home
        </Button>
        
        <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
          <LockOutlinedIcon />
        </Avatar>

        <Paper 
          elevation={3} 
          sx={{ 
            p: 4, 
            width: '100%',
            borderRadius: 2,
            border: '1px solid #e0e0e0'
          }}
        >
          <Box sx={{ textAlign: 'center', mb: 3 }}>
          
            <Typography variant="h4" component="h1" gutterBottom>
              TB Admin Dashboard
            </Typography>
            <Typography align="center" variant="body1" color="text.secondary">
              Login to access the TB administration panel
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <Stack spacing={3}>
              <TextField
                label="Admin Username"
                variant="outlined"
                fullWidth
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoFocus
                disabled={loading}
              />
              <TextField
                label="Password"
                type="password"
                variant="outlined"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
              />
              <Button 
                type="submit" 
                variant="contained" 
                color="primary" 
                size="large"
                fullWidth
                sx={{ py: 1.5 }}
                disabled={loading}
              >
                Login as Administrator
              </Button>
              <Box sx={{ textAlign: 'center' }}>
                <Link href="/login" underline="hover">
                  Return to Patient Login
                </Link>
              </Box>
            </Stack>
          </form>
        </Paper>
      </Box>
    </Container>
  );
};

export default DashboardLogin; 